import { render, staticRenderFns } from "./form-bggs.vue?vue&type=template&id=c2e04fb6&scoped=true&"
import script from "./form-bggs.vue?vue&type=script&lang=js&"
export * from "./form-bggs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e04fb6",
  null
  
)

export default component.exports